"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var defaultContext = {};

var AnalyticsContext = /*#__PURE__*/_react.default.createContext(defaultContext);

AnalyticsContext.displayName = 'AnalyticsEnhance';
var _default = AnalyticsContext;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/analyticsContext.js
// module id = 1814
// module chunks = 25